module.exports = __webpack_public_path__ + "static/media/logo.c0fd57ad.png";